/*
 *   Copyright (c) 2025 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 */
import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { FaTwitter, FaLinkedin, FaFacebook, FaYoutube } from "react-icons/fa"

const SocialLinks = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          socials {
            facebook
            x
            youtube
            linkedin
          }
        }
      }
      strapiSiteSetting {
        socialLinks {
          facebook
          twitter
          youtube
          linkedin
        }
      }
    }
  `)

  // Prioritize Strapi data, fallback to siteMetadata
  const strapiLinks = data.strapiSiteSetting?.socialLinks
  const fallbackLinks = data.site.siteMetadata.socials

  const socialLinks = [
    {
      icon: <FaFacebook color="#ffffff" />,
      url: strapiLinks?.facebook || fallbackLinks.facebook,
      label: "Facebook",
    },
    {
      icon: <FaTwitter color="#ffffff" />,
      url: strapiLinks?.twitter || fallbackLinks.x,
      label: "Twitter",
    },
    {
      icon: <FaYoutube color="#ffffff" />,
      url: strapiLinks?.youtube || fallbackLinks.youtube,
      label: "YouTube",
    },
    {
      icon: <FaLinkedin color="#ffffff" />,
      url: strapiLinks?.linkedin || fallbackLinks.linkedin,
      label: "LinkedIn",
    },
  ].filter(link => link.url)

  return (
    <nav
      aria-label="Social media"
      style={{
        display: "flex",
        gap: "1rem",
        padding: 0,
        margin: 0,
      }}
    >
      {socialLinks.map(({ icon, url, label }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          style={{
            fontSize: "1.25rem",
            color: "#ffffff",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={e => (e.currentTarget.style.opacity = "0.7")}
          onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
        >
          {icon}
        </a>
      ))}
    </nav>
  )
}

export default SocialLinks
